<template>
	<div class="footer-container">
		<div class="main-w">
			<!-- 友情链接 -->
			<div class="links">
				<div class="title">友情链接 | 卫健委直属和联系单位</div>
				<div class="link">
					<a style="color: #fff" target="_blank" :href="link.url" v-for="link in links" :key="link.id">{{ link.name }}</a>
				</div>
				<!-- 分割线 -->
				<div class="line"></div>
				<!-- 版权 -->
				<div class="row cb Copyright">
					<div class="info">
						<p>Copyright@2014 All Rights Reserved. 版权所有 中国医学科学院健康科普研究中心</p>
						<p>地址：北京市东城区东单三条9号 邮编：100730 京ICP备2020042203号-2</p>
						<p v-if="false">联系电话：176-1002-8051 / 182-1100-3670</p>
						<p v-else>联系电话：176-1002-8051</p>
					</div>
					<div class="col cc qr">
						<img src="@/assets/qr.jpg" class="img" />
						<span>联系微信</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { links } from '@/utils/links';
export default {
	data() {
		return {
			links: links
		};
	}
};
</script>

<style lang="less" scoped>
.footer-container {
	margin-top: 50px;
	background: #007575;
	color: #fff;
	font-size: 14px;

	.links {
		width: 100%;
		padding-bottom: 20px;
		background: #007575;
		.title {
			padding: 34px 0;
			font-size: 18px;
			font-weight: bold;
		}
	}
	.link {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		a {
			text-decoration: none;
			margin-bottom: 30px;
			font-size: 14px;
			display: block;
			width: 140px;
			&:hover {
				color: #6dcdba;
			}
		}
	}
	// 分割线
	.line {
		width: 100%;
		height: 1px;
		background-color: #ececec2a;
	}
	// 版权消息
	.Copyright {
		margin-top: 23px;
		.info {
			color: #ffffff;
			line-height: 32px;
			font-size: 14px;
		}
		.qr {
			.img {
				width: 94px;
				height: 94px;
				margin-bottom: 4px;
			}
			color: #ffffff;
			font-size: 14px;
		}
	}
}
</style>
